import { render, staticRenderFns } from "./calendar_pholiday_item.vue?vue&type=template&id=40d99bfc&scoped=true"
import script from "./calendar_pholiday_item.vue?vue&type=script&lang=js"
export * from "./calendar_pholiday_item.vue?vue&type=script&lang=js"
import style0 from "./calendar_pholiday_item.vue?vue&type=style&index=0&id=40d99bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d99bfc",
  null
  
)

export default component.exports